import React, { useState } from 'react';
import { waitlistService } from '@/services/waitlist';
import { usePostHog } from 'posthog-js/react';
import { Button } from '@/components/ui/button';
import { Input } from '@/components/ui/input';

interface Props {
  onSubmit: () => void
};

export const WaitlistForm = ({ onSubmit }: Props) => {
  const posthog = usePostHog();
  const [email, setEmail] = useState('');
  const [status, setStatus] = useState<'idle' | 'loading' | 'success' | 'error'>('idle');
  const [error, setError] = useState<string | null>(null);

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    if (!email) return;
    
    setStatus('loading');
    setError(null);
    posthog.capture('waitlist_signup', { email });
    posthog.setPersonProperties({ email });

    try {
      await waitlistService.register({ email });
      setStatus('success');
      setEmail('');
      onSubmit();
    } catch (err) {
      if (err instanceof Error) {
        setError(err.message);
      } else {
        setError('Something went wrong');
      }
      setStatus('error');
    }
  };

  if (status === 'success') {
    return (
      <div className="text-center p-6 bg-green-50 border border-green-200 rounded-lg">
        <p className="text-green-700 font-medium">Thanks for joining! We'll be in touch soon.</p>
      </div>
    );
  }

  return (
    <div className="bg-card border border-border rounded-lg p-6 shadow-sm">
      <h3 className="text-xl font-semibold mb-2 text-foreground">Join the Early Access</h3>
      <p className="text-muted-foreground mb-4">Be the first to try YakStak when we launch.</p>
      
      <form onSubmit={handleSubmit} className="flex flex-col sm:flex-row gap-3">
        <Input
          type="email"
          placeholder="Enter your email"
          value={email}
          onChange={(e) => setEmail(e.target.value)}
          required
          className="flex-1"
        />
        <Button 
          type="submit" 
          disabled={status === 'loading' || !email}
          className="whitespace-nowrap"
        >
          {status === 'loading' ? 'Joining...' : 'Join Waitlist'}
        </Button>
      </form>
      
      {status === 'error' && (
        <p className="text-destructive text-sm mt-2">{error}</p>
      )}
    </div>
  );
};